import {NEVER, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

import {Injectable} from '@angular/core';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {EventTrackingStore} from '@stores/event-tracking.store';
import {AIProgressMessageStore} from '@stores/ai-progress-message.store';

@Injectable()
export class AIStreamingMessageProcessor implements WebsocketMessageProcessor {
  constructor(
    private wsMessageReceiverService: WSMessageReceiverService,
    private eventTrackingStore: EventTrackingStore,
    private aiProgressMessageStore: AIProgressMessageStore,
  ) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;

    if (msg.int !== APIM.EventIntent.AITextStreamingChunk) {
      return NEVER;
    }

    const activeEvents = this.eventTrackingStore.state();
    if (!activeEvents[msg.id]) {
      console.debug(
        '[AIStreamingMessageProcessor] Ignoring chunk for unknown event:',
        msg.id,
      );
      return of(true);
    }

    return this.wsMessageReceiverService
      .receive<APIM.EventData<APIM.StreamingChunk>>(msg)
      .pipe(
        map((data) => {
          const chunk = data.c[0];
          this.aiProgressMessageStore.ingestChunk(chunk);
          return true;
        }),
      );
  }
}
